// removed by extract-text-webpack-plugin
module.exports = {"scrollbar":"scrollbar-2ZYa-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/styles/perfect-scrollbar.less
 ** module id = 159
 ** module chunks = 0
 **/